import { call, put, takeLatest, all, select, delay } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';

function* fetchAuxiliaryGrid({ auxGridParams }) {
  let token = true,
    getToken;
  while (token) {
    try {
      yield put(Actions.setLoader({ showLoader: true }));
      const { data } = yield call(api.get, {
        route: `Dashboards/auxiliary?factoryId=` + auxGridParams.factoryId + `&groupId=` + auxGridParams.groupId,
      });
      const auxGrid = data;
      yield put(Actions.setAuxiliaryGrid({ auxGrid }));
      yield put(Actions.setLoader({ showLoader: false }));

      yield delay(60000, true);
      getToken = state => state.services.common.getIn(['ajaxCallLoopAux']);
      token = yield select(getToken);
    } catch (err) {
      console.warn(err); // Handle exception
      yield put(Actions.setLoader({ showLoader: false }));
    }
  }
}

export default function* rootSaga() {
  yield all([takeLatest(ActionTypes.FETCH_AUXILIARY_GRID, fetchAuxiliaryGrid)]);
}
